<div class="auto-complete-container">
    <input
        type="text"
        validate
        required
        [(ngModel)]="searchValue"
        name="searchValue"
        regexPattern="^[a-zA-Z0-9]+$"
        placeholder="{{ placeHolder }}"
        (keyup)="sendSearchValue($event.target.value)"
        (blur)="onClickAway()"
        id="{{id}}"
        [disabled]="disabled"
    />
</div>
